import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Text = styled.p`
  width: 100%;
  text-: 20px;
  font-size: 8.5px;
  font-family: ${props => props.weight};
  font-weight: normal;
  color: #7d7773;
  line-height: 1.2;
  text-transform: none;
  margin: 1px;
  text-decoration: underline;
  cursor: pointer;
  :focus {
    color: #5bb9ef;
  }
  :active {
    color: #5bb9ef;
  }
`;

const Container = styled.div`
  display: grid;
  text-align: center;
  width: 100%;
  margin-top: 0.5em;
`;

export default class ClearSelection extends PureComponent {
  clearSelection() {
    const { clearSelection, moveNodeToHome } = this.props;
    clearSelection(true);
    if (moveNodeToHome) moveNodeToHome();
  }
  render() {
    return (
      <Container>
        <Text
          weight="HelveticaNeueLTPro-Md"
          onClick={this.clearSelection.bind(this)}
        >
          Clear Selections
        </Text>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClearSelection.js